import { DialogRef } from '@angular/cdk/dialog';
import { Component } from '@angular/core';

@Component({
	selector: 'app-teranet-summary-modal',
	templateUrl: './modal.component.html',
	styleUrls: ['./modal.component.scss'],
	standalone: false,
})
export class TeranetSummaryModalComponent {
	constructor(private modal: DialogRef<TeranetSummaryModalComponent>) {}
}
